import React from 'react';
import {
  FaBriefcase, FaGraduationCap, FaBook, FaChalkboard,
  FaLaptopCode, FaUniversity, FaDownload,
} from 'react-icons/fa';
import { FaGoogle, FaHandshakeAngle } from 'react-icons/fa6';
import SectionTitle from '../components/shared/SectionTitle';
import '../styles/resume.css';

const experience = [
  {
    date: '2025 – Present',
    role: 'Half Container Library Manager',
    org: 'African Library Project · Remote',
    icon: <FaBook />,
    duties: [
      'Managed data for two shipping containers annually, supporting 30–60 libraries.',
      'Tracked book drive participation in Excel and Salesforce — organizers, timelines, library assignments.',
      'Monitored logistics metrics to optimize efficiency and reduce scheduling risks.',
      'Collaborated with volunteers to grow participation by 20% annually.',
    ],
  },
  {
    date: '08/2024 – 08/2025',
    role: 'Community Development Facilitator',
    org: 'CorpsAfrica · Tamale',
    icon: <FaHandshakeAngle />,
    duties: [
      'Started a reading club for Basic 4–6 students — 60% reading engagement increase in 3 months.',
      'Conducted household water needs survey across 25+ homes.',
      'Facilitated 6+ community meetings with teachers, leaders, and parents.',
      'Designed surveys impacting 30% of local households.',
    ],
  },
  {
    date: '07/2019 – 06/2020',
    role: 'Teacher',
    org: 'Agdam International School · Wa',
    icon: <FaChalkboard />,
    duties: [
      'Facilitated English and literacy for 30+ pupils aged 8–12.',
      '10+ learners recorded 20–30% increase in test scores.',
      'Increased class participation by 25% through learner-centred lesson plans.',
    ],
  },
];

const education = [
  {
    date: '2023 – 2024',
    role: 'BS Data Analytics Fellowship',
    org: 'Blossom Academy',
    icon: <FaLaptopCode />,
    duties: ['Excel, Power BI, SQL & Python curriculum'],
  },
  {
    date: 'Graduated',
    role: 'BA Public Administration & Information',
    org: 'University of Ghana',
    icon: <FaUniversity />,
    duties: [],
  },
  {
    date: 'Certifications',
    role: 'Google Data Analytics Professional',
    org: 'Google via Coursera',
    icon: <FaGoogle />,
    duties: [
      'Introduction to Data Analysis — Rice University',
      'Excel Skills for Business — Macquarie University',
      "The Data Scientist's Toolbox — Johns Hopkins University",
    ],
  },
];

const skillGroups = [
  { name: 'Visualization', skills: ['Microsoft Excel', 'Power BI', 'Tableau', 'Looker Studio'] },
  { name: 'Programming',   skills: ['SQL', 'Python', 'R'] },
  { name: 'Libraries',     skills: ['Pandas', 'NumPy', 'Scikit-learn', 'Seaborn'] },
  { name: 'Other Tools',   skills: ['Salesforce', 'Google Workspace', 'GitHub', 'MS Office'] },
];

function TimelineItem({ item }) {
  return (
    <div className="timeline__item">
      <div className="timeline__header">
        <div className="timeline__logo">{item.icon}</div>
        <div className="timeline__meta">
          <p className="timeline__date">{item.date}</p>
          <h4 className="timeline__role">{item.role}</h4>
          <p className="timeline__org">{item.org}</p>
        </div>
      </div>
      {item.duties.length > 0 && (
        <ul className="timeline__duties">
          {item.duties.map((d) => <li key={d}>{d}</li>)}
        </ul>
      )}
    </div>
  );
}

function Resume() {
  return (
    <section className="resume section" id="background">
      <div className="container">
        <SectionTitle label="My Journey" title="Education &amp; Experience" />
        <div className="resume__layout">
          <div>
            <h3 className="resume__col-title"><FaBriefcase /> Experience</h3>
            <div className="timeline">
              {experience.map((item) => <TimelineItem key={item.role} item={item} />)}
            </div>
          </div>
          <div>
            <h3 className="resume__col-title"><FaGraduationCap /> Education</h3>
            <div className="timeline">
              {education.map((item) => <TimelineItem key={item.role} item={item} />)}
            </div>
            <div className="resume__skills">
              {skillGroups.map((g) => (
                <div className="skills-group" key={g.name}>
                  <p className="skills-group__name">{g.name}</p>
                  <div className="skills-group__list">
                    {g.skills.map((s) => <span className="tag" key={s}>{s}</span>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="resume__download">
          <a href="/HaadiYakubu_DataAnalyst_Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn-primary">
            <FaDownload /> Download Full Resume
          </a>
        </div>
      </div>
    </section>
  );
}

export default Resume;